var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSouthAfrica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 480,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.005 382.304V97.873l211.777 142.216L-.098 382.304h.093z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.461 480.083l237.745-159.934h337.68V479.99H144.461v.093z",
    fill: "#00C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.274 0h590.612v160.122H382.112S132.367-1.594 129.274 0z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.005 59.999v37.874l211.777 142.122L-.098 382.304v37.781l266.713-179.996L-.099 59.999h.094z",
    fill: "#FC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.005 59.999V0h89.06l282.37 191.246H719.98v97.685H371.425L88.962 479.99H-.005v-59.905l266.619-179.996L.089 59.999h-.094z",
    fill: "#093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.962 0h55.499l237.745 160.028h337.68v31.218H371.425L88.962.094V0zm0 480.084h55.499l237.745-159.935h337.68v-31.124H371.425L88.962 479.99v.094z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica);
export default __webpack_public_path__ + "static/media/South-Africa.ad6242e8424c8340f4dc5ddb67758aa7.svg";
export { ForwardRef as ReactComponent };